import { EPredicateFields } from '@common/definitions';
import type { Predicate } from '@common/types/objects';
import { predicatesToPayload } from '@utils/predicates';

function hasNonEmptyNetworkPredicate(predicates: Predicate[] | undefined): boolean {
  return predicatesToPayload(predicates || []).some(
    (predicate) => predicate.attribute === EPredicateFields.NETWORK &&
      Array.isArray(predicate.value) &&
      predicate.value.length > 0
  );
}

/**
 * Empty / non-network-only predicates on `/users/search` can return users
 * outside the communities a network-scoped admin may manage.
 * Callers must pass `allowOrganisationWideAudienceSearch: false` for those
 * roles so we only search when a community (NETWORK) predicate is present.
 */
export function shouldSkipEmptyAudienceUserSearch(
  allowOrganisationWideAudienceSearch: boolean,
  predicates: Predicate[] | undefined
): boolean {
  if (allowOrganisationWideAudienceSearch) return false;
  return !hasNonEmptyNetworkPredicate(predicates);
}

export function emptyAudienceUserSearchResponse(limit = 10) {
  return {
    data: [] as Record<string, unknown>[],
    meta: {
      pagination: {
        total_count: 0,
        offset: 0,
        limit,
      },
    },
  };
}
